import type { FaireProductEntity } from "../../entity_types/product";

export const p_2hg3bxnwk4: FaireProductEntity = {
  token: "p_2hg3bxnwk4",
  type: "product",
  name: "Piñon– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/bafb94c708897e5b916edb8fdddcf65c030c6770f6ae2c2807980cb180a3ff1c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/11c3ee99dbacb480a5cdeb9eee889e5643d7383e6ccb893244d7d821c20680b5.jpeg",
    "https://cdn.faire.com/fastly/5877386a9dea2c5890abd0d9749d4b08647917f43869239472309954ba12f82f.jpeg",
    "https://cdn.faire.com/fastly/fcca0457464b04242d8eebac24e83c2eece21938a68efe450ee10a59121d994a.jpeg",
    "https://cdn.faire.com/fastly/a920a73637992955a1795c0f1290af3274417fb25ee0eea2342ff0310eecd94e.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Winters in the Southwest, lingering bonfires, wool jackets in rotation. Piñon logs, cedar, and vanilla.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:51.960Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
